import { render } from "./EconomicsForm.vue?vue&type=template&id=6166483f&scoped=true"
import script from "./EconomicsForm.vue?vue&type=script&lang=js"
export * from "./EconomicsForm.vue?vue&type=script&lang=js"

import "./EconomicsForm.vue?vue&type=style&index=0&id=6166483f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166483f"]])

export default __exports__